// extracted by mini-css-extract-plugin
module.exports = {"cntr":"index-module_cntr-e0hUh"};